import {Component, Input} from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {MatIcon} from '@angular/material/icon';
import {MatAnchor} from '@angular/material/button';
import {DatePipe, NgIf, NgOptimizedImage} from '@angular/common';
import {MatCard} from '@angular/material/card';

@Component({
    selector: 'icon-text',
    templateUrl: './icon-text.component.html',
    styleUrls: ['./icon-text.component.scss'],
    standalone: true,
  imports: [MatCard, NgIf, MatAnchor, MatIcon, DatePipe, TranslateModule, NgOptimizedImage]
})
export class IconTextComponent {

  @Input() icon!: string;
  @Input() textBold!: string;
  @Input() text!: string;
}
